import _defineProperty from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
/***************************************************
 * [Quasar Cookies] http://quasar-framework.org/components/cookies.html
 * [Quasar LocalStorage] http://quasar-framework.org/components/web-storage.html
 **************************************************/

import Cookies from 'quasar/src/plugins/Cookies.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
import HttpService from "./auth.service";
import Config from "../config";
import store from "../store";
import moment from 'moment';

// const Store = store()
var OAuth = /*#__PURE__*/function () {
  function OAuth() {
    _classCallCheck(this, OAuth);
    this.storages = {
      Cookies: Cookies,
      LocalStorage: LocalStorage
    };
    this.Store = store();
    this.storageType = Config('auth.default_storage');
    this.session = this.storages[this.storageType];
  }

  // Unified storage interface to handle API differences
  return _createClass(OAuth, [{
    key: "has",
    value: function has(key) {
      if (this.storageType === 'LocalStorage') {
        return this.session.has(key);
      } else {
        // For Cookies, use static method
        return Cookies.has(key);
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      if (this.storageType === 'LocalStorage') {
        return this.session.get(key);
      } else {
        // For Cookies, use static method
        var value = Cookies.get(key);
        return value;
      }
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (this.storageType === 'LocalStorage') {
        this.session.set(key, value);
      } else {
        // For Cookies, use static method
        Cookies.set(key, value, options);
      }
    }
  }, {
    key: "remove",
    value: function remove(key) {
      if (this.storageType === 'LocalStorage') {
        this.session.remove(key);
      } else {
        // For Cookies, use static method with proper options
        var removeOptions = {
          path: '/'
        };

        // Remove with domain for production, without for localhost
        if (window.location.hostname.includes('moneyboat.co.uk')) {
          removeOptions.domain = '.moneyboat.co.uk';
        }
        Cookies.remove(key, removeOptions);
      }
    }
  }, {
    key: "logout",
    value: function logout() {
      this.remove('access_token');
      this.remove('refresh_token');
      this.remove('login_date');
      this.Store.dispatch('users/destroyCurrentUser');
    }
  }, {
    key: "guest",
    value: function guest() {
      return !this.has('access_token');
    }
  }, {
    key: "isAuthenticated",
    value: function isAuthenticated() {
      return this.has('access_token');
    }
  }, {
    key: "login",
    value: function login(username, password) {
      var _this = this;
      var data = {
        username: username,
        password: password
      };

      // We merge grant type and client secret stored in configuration
      Object.assign(data, Config('auth.oauth'));
      return new Promise(function (resolve, reject) {
        HttpService.attemptLogin(data).then(function (response) {
          _this.storeSession(response.data);
          _this.Store.dispatch('users/getCurrentUser');
          resolve(_this.Store.state.users.currentUser);
        }).catch(function (error) {
          // console.log('OAUTH Authentication error: ', error)
          reject(error);
        });
      });
    }
  }, {
    key: "currentUser",
    value: function currentUser() {
      var _this2 = this;
      if (this.has('access_token')) {
        return new Promise(function (resolve, reject) {
          if (_this2.Store.state.users.currentUser) {
            // console.log('have existing user')
            resolve(_this2.Store.state.users.currentUser);
            return;
          }
          HttpService.currentUser().then(/*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
              return _regeneratorRuntime.wrap(function (_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 1;
                    return _this2.Store.dispatch('users/getCurrentUser');
                  case 1:
                    resolve(_this2.Store.state.users.currentUser);
                  case 2:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).catch(function (error) {
            if (error.response && (error.response.status === 401 || error.response.status === 429)) {
              try {
                _this2.logout();
              } catch (logoutError) {
                // eslint-disable-next-line no-console
                console.error('Logout error:', logoutError);
              }
            }
            reject(error);
          });
        });
      }
      return new Promise(function (resolve) {
        return resolve(null);
      });
    }
  }, {
    key: "getAuthHeader",
    value: function getAuthHeader() {
      if (this.has('access_token')) {
        var accessToken = this.get('access_token');
        return Config('auth.oauth_type') + ' ' + accessToken;
      }
      return null;
    }
  }, {
    key: "storeSession",
    value: function storeSession(data) {
      var expiresInSeconds = data.expires_in || 86400;
      var secondsInDay = 86400;
      var timeInDays = expiresInSeconds / secondsInDay;
      if (this.storageType === 'LocalStorage') {
        this.set('access_token', data.access_token);
        this.set('refresh_token', data.refresh_token);
        this.set('login_date', moment().toISOString());
      } else {
        /*
        **  when the Storage is type Cookies
        **  we send the expires property given in days
        */
        var cookieOptions = {
          expires: timeInDays,
          path: '/'
        };

        // Set domain for production, omit for localhost development
        if (window.location.hostname.includes('moneyboat.co.uk')) {
          cookieOptions.domain = '.moneyboat.co.uk';
        }
        this.set('access_token', data.access_token, cookieOptions);

        /*
         ** We duplicate the time because,
         ** in theory it lasts the double of time access token duration
         */
        this.set('refresh_token', data.refresh_token, _objectSpread(_objectSpread({}, cookieOptions), {}, {
          expires: timeInDays * 2
        }));

        // Set login_date for cookies as well
        this.set('login_date', moment().toISOString(), cookieOptions);
      }
    }
  }]);
}();
export default OAuth;